module.exports = __webpack_public_path__ + "static/media/daily.d4e56f26.gif";